import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class DashboardService {

  private _erCoverageReportUrl = CONFIGURATION.baseServiceUrl + 'ercoveragereportservice/';
 
  private apiurl = CONFIGURATION.baseServiceUrl + 'payrolloverviewdashboardservice/';

  constructor(private _http: Http) { }

  getFilterData(data:any) {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.apiurl + 'payrolloverviewdashboardcount', data, { headers: headers }).map((response: Response) => response.json())
  }

  getTaxyears(data:any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.apiurl + 'referenceData', data, { headers: headers })
      .map((response: Response) => response.json())
  }
  getProductionData(data:any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.apiurl + 'payrolloverviewdashboarddetails', data, { headers: headers })
      .map((response: Response) => response.json())
  }

  getChartsData(controlgroup:any, taxyear:any) {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'graphcount-shows?ControlGroup='+controlgroup+'&TaxYear='+taxyear, { headers: headers }).map((response: Response) => response.json())
  }

  downloadPDF(year:any,controlGroup:any): any {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    // headers.append('Authorization', 'JWT ' + localStorage.getItem('id_token'));
    return this._http.get(`${this._erCoverageReportUrl}processERCoverageReportPDFUpload?WorkYear=${year}&ControlGroup=${controlGroup}`, { headers: headers, responseType: ResponseContentType.Blob }).map(
        (res) => {
            const a = document.createElement('a');
            document.body.appendChild(a);
            const blob = new Blob([res.blob()], { type: 'application/pdf' });
            const downloadUrl = URL.createObjectURL(blob);
            window.open(downloadUrl);
        })
}
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.service.ts